<template>
  <div class="mobileViewStyle staff-detail">
    <!-- 系统管理-职员档案（企业微信手机端，新增 / 编辑 / 删除） -->
    <div class="detail-body">
      <list-card :label="isEdit ? '编辑职员档案' : '新增职员档案'" type="form">
        <data-input v-if="!isEdit" label="选择职员">
          <mobile-search-select class="row-select" v-model="form.employeeId" :query="queryEmployeePage"
                                label-column="employeeName" code-column="id"
                                :display-text="form.employeeName" placeholder="请选择职员"
                                search-placeholder="职员名称/手机号" @change="onEmployeeChange"/>
        </data-input>
        <data-input v-else label="选择职员" :model-value="form.employeeName" disabled/>
        <data-input label="联系电话" :model-value="form.employeePhone" disabled/>
        <data-input label="角色">
          <span class="row-text" :class="{placeholder: !selectedRoleNames}" @click="openRoleDrawer">
            {{ selectedRoleNames || "请选择角色" }}
          </span>
        </data-input>
      </list-card>
    </div>

    <div class="detail-footer">
      <mobile-button v-if="isEdit" el-type="danger" @click="deleteRow">删除</mobile-button>
      <mobile-button @click="cancel">取消</mobile-button>
      <mobile-button el-type="primary" @click="save">保存</mobile-button>
    </div>

    <!-- 角色多选抽屉 -->
    <mobile-drawer v-model="showRoleDrawer" title="选择角色" @confirm="confirmRoles" @cancel="cancelRoles">
      <div class="role-drawer">
        <div class="role-row" v-for="role in roleOptions" :key="role.id" @click="toggleRole(role)">
          <span class="role-name">{{ role.roleName }}</span>
          <yq-icon v-if="tempRoleIds.includes(role.id)" class="selected" name="element-ui_check"/>
        </div>
        <div v-if="roleOptions.length === 0" class="empty">暂无角色</div>
      </div>
    </mobile-drawer>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {ElMessageBox} from "element-plus";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataInput from "@/components/qywx/data/DataInput.vue";
import MobileSearchSelect from "@/components/qywx/data/MobileSearchSelect.vue";
import MobileDrawer from "@/components/qywx/data/MobileDrawer.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";
import YqIcon from "@/components/YqIcon.vue";
import staffEmployeeApi from "@/api/dz-crm/sys/staffEmployeeApi";
import roleApi from "@/api/normal/sys/roleApi";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "StaffEmployeeDetailQW",
  components: {
    YqIcon, MobileButton, MobileDrawer, MobileSearchSelect, DataInput, ListCard
  },
  data() {
    return {
      form: {
        id: "",
        employeeId: "",
        employeeName: "",
        employeePhone: "",
        roleIdArr: [],
      },
      roleOptions: [],
      showRoleDrawer: false,
      tempRoleIds: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.form.id;
    },
    selectedRoleNames() {
      return this.form.roleIdArr
          .map(id => {
            const role = this.roleOptions.find(r => r.id === id);
            return role ? role.roleName : "";
          })
          .filter(name => name)
          .join("、");
    }
  },
  created() {
    // 列表把已选职员与角色带过来（编辑不换职员，只改角色）
    const query = this.route.query || {};
    this.form.id = query.id || "";
    this.form.employeeId = query.employeeId || "";
    this.form.employeeName = query.employeeName || "";
    this.form.employeePhone = query.employeePhone || "";
    this.form.roleIdArr = query.roleIds ? String(query.roleIds).split(",").filter(id => id) : [];
    roleApi.queryAllRoles().then(list => this.roleOptions = list || []);
  },
  methods: {
    queryEmployeePage(params) {
      return commonApi.queryEmployeeListByPage(params);
    },
    onEmployeeChange(record) {
      if (!record) {
        this.form.employeeName = "";
        this.form.employeePhone = "";
        return;
      }
      this.form.employeeName = record.employeeName || "";
      this.form.employeePhone = record.employeePhone || "";
    },
    // ---------- 角色多选 ----------
    openRoleDrawer() {
      this.tempRoleIds = this.form.roleIdArr.slice();
      this.showRoleDrawer = true;
    },
    toggleRole(role) {
      const index = this.tempRoleIds.indexOf(role.id);
      if (index > -1) {
        this.tempRoleIds.splice(index, 1);
      } else {
        this.tempRoleIds.push(role.id);
      }
    },
    confirmRoles() {
      this.form.roleIdArr = this.tempRoleIds.slice();
    },
    cancelRoles() {
      // 点遮罩/取消只丢弃待选，不动已选
      this.tempRoleIds = [];
    },
    // ---------- 保存 / 删除 ----------
    save() {
      if (!this.form.employeeId) {
        this.$message.error("请选择职员");
        return;
      }
      if (!this.form.roleIdArr.length) {
        this.$message.error("请选择角色");
        return;
      }
      staffEmployeeApi.save({
        id: this.form.id,
        employeeId: this.form.employeeId,
        roleIdArr: this.form.roleIdArr,
      }).then(() => this.router.back());
    },
    deleteRow() {
      ElMessageBox.confirm("是否确认将该职员从平台移除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        staffEmployeeApi.delete(this.form.id).then(() => this.router.back());
      }).catch(() => {
      });
    },
    cancel() {
      this.router.back();
    },
  }
};
</script>

<style lang="scss" scoped>
.staff-detail{
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-body{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
  }
  .row-select{
    max-width: 100%;
  }
  .row-text{
    color: var(--yq-font-color-base);
    &.placeholder{
      color: var(--yq-font-color-desc);
    }
  }
  .detail-footer{
    flex: none;
    display: flex;
    gap: 10px;
    padding: 10px;
    background: #FFF;
    box-shadow: 0 -1px 4px var(--yq-shadow);
    :deep(.mobile-button){
      flex: 1;
    }
  }
}
.role-drawer{
  height: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  overflow-y: auto;
  .role-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 50px;
    border-bottom: 1px solid var(--yq-border-color);
    font-size: var(--yq-font-size-large-mobile);
    .role-name{
      flex: 1;
      min-width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .selected{
      flex: none;
      color: var(--el-color-success);
    }
  }
  .empty{
    padding: 30px 0;
    text-align: center;
    font-size: var(--yq-font-size-mini-mobile);
    color: var(--yq-font-color-desc);
  }
}
</style>
